import React from "react";
import { Typography } from "antd";
import { ParagraphProps } from "antd/lib/typography/Paragraph";
import classnames from "classnames";
import { TestID } from "../../shared/testids/testids";
import { Merge } from "../../shared/TypeScriptHelpers";
import "./COREBody.less";
import { AllColorHEX } from "../Content/COREColour";
import { CORETruncateText, CORETruncateTextProps } from "./CORETruncateText";

const { Paragraph } = Typography;

export type COREBodyProps = Merge<
  Pick<
    ParagraphProps,
    "underline" | "italic" | "strong" | "children" | "onClick" | "ellipsis"
  >,
  {
    type?: "p1" | "p2" | "p3" | "p4" | "p5";
    testID?: TestID;
    marginBottom?: boolean;
    className?: string;
    inline?: boolean;
    color?: AllColorHEX;
    textWrap?: boolean;
    alignCenter?: boolean;
  }
>;

export const COREBody: React.FC<COREBodyProps> = ({
  underline,
  italic,
  strong,
  children,
  type = "p2",
  testID,
  marginBottom = true,
  textWrap = true,
  className,
  inline = false,
  color,
  onClick,
  ellipsis,
  alignCenter,
}) => {
  const classes = classnames([
    "core-body",
    type,
    className,
    { "no-margin-bottom": !marginBottom },
    { inline: inline },
    { onClick: onClick },
    { "no-text-wrap": !textWrap },
    { "align-center": alignCenter },
  ]);
  return (
    <Paragraph
      onClick={onClick}
      data-testid={testID}
      underline={underline}
      italic={italic}
      strong={strong}
      className={classes}
      ellipsis={ellipsis}
      {...(color && { style: { color: color } })}
    >
      {children}
    </Paragraph>
  );
};

export const COREBodyTruncateWithTooltip: React.FC<
  Omit<COREBodyProps, "testID"> &
    Required<Pick<COREBodyProps, "testID">> &
    Pick<
      CORETruncateTextProps,
      "truncateAfter" | "messageTooltip" | "tooltipPosition" | "tooltipWidth"
    >
> = ({
  truncateAfter,
  messageTooltip,
  testID,
  tooltipPosition,
  tooltipWidth,
  children,
  ...coreBodyProps
}) => {
  return (
    <CORETruncateText
      truncateAfter={truncateAfter}
      messageTooltip={messageTooltip ? messageTooltip : children}
      testID={testID}
      tooltipPosition={tooltipPosition}
      tooltipWidth={tooltipWidth}
    >
      <COREBody testID={testID} {...coreBodyProps}>
        {children}
      </COREBody>
    </CORETruncateText>
  );
};
